import instance from "../config/interceptor";
import { supabase, updateSupabaseSession } from "../utils/supabaseClient";
import { BASE_API_URL } from "../config/api";

export const registerAccount = async (data) => {
  let _response;
  try {
    const response = await instance.post(
      `${BASE_API_URL}/register`,
      data
    );
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const loginAccount = async (data) => {
  try {
    const { data: authData, error } = await supabase.auth.signInWithPassword({
      email: data.username,
      password: data.password,
    });

    if (error || !authData?.session) {
      return {
        status: 401,
        data: { detail: error?.message || "Login failed" },
      };
    }

    const { session } = authData;
    return {
      status: 200,
      data: {
        id_token: session.access_token,
        refresh_token: session.refresh_token,
        expiresIn: session.expires_in,
        expiry_date: session.expires_in,
      },
    };
  } catch (error) {
    return {
      status: 401,
      data: { detail: error?.message || "Login failed" },
    };
  }
};

export const accountActivation = async (key) => {
  let _response;
  try {
    const { response } = await instance.get(
      `${BASE_API_URL}/activate?key=${key}`
    );
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const getAccountContent = async () => {
  let _response;
  try {
    const response = await instance.get(
      `${BASE_API_URL}/account`
    );
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const initResetPassword = async (email) => {
  const response = await instance.post(
    `${BASE_API_URL}/account/reset-password/init`,
    email,
    {
      headers: {
        "Content-Type": "text/plain",
      },
    }
  );
  if (response.status !== 200) {
    throw new Error(response.data.message || "Something went wrong!");
  }
  return response;
};

export const validateResetPassword = async (key) => {
  let _response;
  try {
    const request = await instance.get(
      `${BASE_API_URL}/account/reset-password/validate?key=${key}`
    );
    _response = request;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const finishInitResetPassword = async (data) => {
  let _response;
  try {
    const { response } = await instance.post(
      `${BASE_API_URL}/account/reset-password/finish`,
      data,
      {
        headers: {
          "Content-Type": "application/problem+json",
        },
      }
    );

    _response = response;
  } catch ({ response }) {
    _response = response;
  }

  return _response;
};

export const onboardingAccount = async (data) => {
  let _response;
  try {
    await updateSupabaseSession();
    const { data: resData, error } = await supabase
      .schema("ehealth")
      .rpc("api2_complete_onboarding", {
        p_onboard: data,
      });

    if (error) {
      _response = { response: { data: error, status: 500 } };
    } else {
      _response = { data: resData, status: 200 };
    }
  } catch (error) {
    _response = { response: error };
  }
  return _response;
};

export const changePassword = async (data) => {
  let _response;
  try {
    const response = await instance.post(
      `${BASE_API_URL}/account/change-password`,
      data
    );
    _response = response;
  } catch (err) {
    _response = err;
  }
  return _response;
};
